import { apiUrl } from '../config/paths';

// Типы
export interface PiracySummary {
  reports: { total: number; shift: number; week: number; month: number };
  openTransits: number;
  activeVessels: number;
  areas: { id: number; code: string; name: string }[];
}

export interface PiracyReport {
  id: number;
  transit_id: number | null;
  vessel_id: number | null;
  area_id: number | null;
  latitude: number | null;
  longitude: number | null;
  position_time: string | null;
  course: number | null;
  speed: number | null;
  raw_subject: string | null;
  raw_body: string | null;
  source_email: string | null;
  created_at: string;
  vessel?: { id: number; vessel_name: string; mmsi: string | null };
  area?: { id: number; code: string; name: string };
}

export interface PiracyArea {
  id: number;
  code: string;
  name: string;
  priority: number;
  geometry: Record<string, unknown>;
  match_keywords: string[];
  is_active: boolean;
  risk_level: string;
  description: string | null;
}

export interface PiracyTransit {
  id: number;
  status: string;
  report_count: number;
  opened_at: string;
  closed_at: string | null;
  vessel?: { id: number; vessel_name: string; mmsi: string | null };
  area?: { id: number; code: string; name: string };
}

const getAuthHeaders = (): HeadersInit => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    Authorization: token ? `Bearer ${token}` : '',
  };
};

const handleResponse = async <T>(response: Response): Promise<T> => {
  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Ошибка' }));
    throw new Error(error.message || `HTTP ${response.status}`);
  }
  return response.json();
};

export const getSummary = async (): Promise<PiracySummary> => {
  const r = await fetch(apiUrl('admin/piracy/summary'), { headers: getAuthHeaders() });
  return handleResponse<PiracySummary>(r);
};

export const getReports = async (limit = 50): Promise<PiracyReport[]> => {
  const r = await fetch(apiUrl(`admin/piracy/reports?limit=${limit}`), {
    headers: getAuthHeaders(),
  });
  return handleResponse<PiracyReport[]>(r);
};

export const getAreas = async (): Promise<PiracyArea[]> => {
  const r = await fetch(apiUrl('admin/piracy/areas'), { headers: getAuthHeaders() });
  return handleResponse<PiracyArea[]>(r);
};

export const getOpenTransits = async (): Promise<PiracyTransit[]> => {
  const r = await fetch(apiUrl('admin/piracy/transits/open'), { headers: getAuthHeaders() });
  return handleResponse<PiracyTransit[]>(r);
};

export const closeTransit = async (transitId: number): Promise<Record<string, unknown>> => {
  const r = await fetch(apiUrl(`admin/piracy/transits/${transitId}/close`), {
    method: 'POST',
    headers: getAuthHeaders(),
  });
  return handleResponse<Record<string, unknown>>(r);
};

export const piracyApiKeys = {
  summary: ['piracy', 'summary'] as const,
  reports: ['piracy', 'reports'] as const,
  areas: ['piracy', 'areas'] as const,
  openTransits: ['piracy', 'openTransits'] as const,
};

export default { getSummary, getReports, getAreas, getOpenTransits, closeTransit };
